import { UserManager } from "oidc-client";
import * as React from "react";

// ATTRIBUTE PROPS
interface IProps {
    userManager: UserManager;
}

class Login extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);

        // Check to see if there is a redirect url to maintain via state
        const urlParams = new URLSearchParams(window.location.search);
        const redirectUrl = urlParams.get('redirectUrl');

        if (redirectUrl) {
            // Perform the redirect
            this.props.userManager.signinRedirect({
                state: redirectUrl
            });
        } else {
            this.props.userManager.signinRedirect();
        }
    }

    public render() {
        return null;
    }
}

export default Login;
